import request from '../request';

export default {
  //作品-添加
  add(data) {
    return request.post('/works/add', data);
  },

  //作品-修改
  edit(data) {
    return request.post('/works/edit', data);
  },

  //作品-列表
  lists(data) {
    return request.get('/works/lists', data);
  },

  //作品-删除
  delete(data) {
    return request.post('/works/delete', data);
  },

  //作品-详情
  detail(data) {
    return request.get('/works/detail', data);
  },

  //作品-分类
  getCategory(data) {
    return request.get('/works/getCategory', data);
  },

  //作品-场景列表
  getSceneList(data) {
    return request.get('/works/getSceneList', data);
  },

  //作品-新增场景
  addScene(data) {
    return request.post('/works/addScene', data);
  },

  //作品-删除场景
  deleteScene(data) {
    return request.post('/works/deleteScene', data);
  },

  //作品-修改场景
  editScene(data) {
    return request.post('/works/editScene', data);
  },

  //作品-更新
  update(data) {
    return request.post('/works/update', data);
  },

  //作品-获取场景数据单条
  getSceneDetail(data) {
    return request.get('/works/getSceneDetail', data);
  },

  //区域-已绑定vr列表
  bindList(data) {
    return request.get('/CityPlateWorks/list', data);
  },

  //区域-绑定操作
  bind(data) {
    return request.post('/CityPlateWorks/bind', data);
  },

  //区域-推荐
  plateUpdate(data) {
    return request.post('/CityPlateWorks/update', data);
  },

  //区域 sort
  plateSort(data) {
    return request.post('/CityPlateWorks/sort', data);
  },

  //获取VR区域列表
  getArea(data) {
    return request.get('/works/getArea', data);
  },

  //新增热点-选择场景列表
  getGroupSceneList(data) {
    return request.get('/works/getGroupSceneList', data);
  },

  //vr作品-复拍
  retakeWorks(data) {
    return request.post('/works/retakeWorks', data);
  },

  //作品配置-场景排序
  sceneSort(data) {
    return request.post('/works/sceneSort', data);
  },

  //项目权限
  getAuth(data) {
    return request.get('/works/getAuth', data);
  },

  //复拍上传
  retake(data) {
    return request.post('/material/retake', data);
  },

  getRetakeList(data) {
    return request.get('/material/getRetakeList', data);
  },

  deleteRetake(data) {
    return request.post('/material/deleteRetake', data);
  },

  planList(data) {
    return request.get('/works/planList', data);
  },

  updatePlan(data) {
    return request.post('/works/updatePlan', data);
  },

  addPlan(data) {
    return request.post('/works/addPlan', data);
  },

  deletePlan(data) {
    return request.post('/works/deletePlan', data);
  },

  retakeErrorData(data) {
    return request.get('/works/retakeErrorData', data);
  },

  syncSpotData(data) {
    return request.post('/works/syncSpotData', data);
  },
	
	copyData(data) {
		return request.post('/works/copyData', data);
	},
};
